import { FC } from 'react'

import { observer } from 'mobx-react-lite'

import { mplusStore } from 'entities/mplus/module/mplus-store'
import { MbankInstallment } from 'entities/mplus/ui/mbank-installment'
import { ProsMplus } from 'entities/mplus/ui/pros-mplus'
import { TakeInMplus } from 'entities/mplus/ui/take-in-mplus'
import { TotalPrice } from 'entities/mplus/ui/total-price'

interface Props {}

export const MplusInfoScoring: FC<Props> = observer(({}) => {
  const installmentInfo = mplusStore.getInstallmentInfo()
  return (
    <div className="container">
      <MbankInstallment />
      <ProsMplus />
      <TakeInMplus />
      <TotalPrice
        totalInfo={installmentInfo?.total_amount}
        monthPayInfo={installmentInfo?.monthly_amount}
      />
    </div>
  )
})
